import {
  Modal,
  ModalBody,
  ModalFoot,
  ModalHead,
  Page,
} from '@dixa/lib-shared-habla';
import { useEffect, useState } from 'react';

import styles from './whatsAppOnboarding.module.scss';

/* This component is temporary and serves the purpose of getting Facebook approval. */
export const WhatsAppOnboarding = (): JSX.Element => {
  const [isOpen, setIsOpen] = useState(false);
  const [wabaId, setWabaId] = useState('');
  const [phoneNumberId, setPhoneNumberId] = useState('');

  useEffect(() => {
    const embeddedSignupInfoListener = (event) => {
      if (event.origin !== 'https://www.facebook.com') return;
      try {
        const data = JSON.parse(event.data);
        if (data.type === 'WA_EMBEDDED_SIGNUP') {
          if (data.event === 'FINISH' || data.event === 'FINISH_ONLY_WABA') {
            const { phone_number_id, waba_id } = data.data;
            console.log({ phone_number_id, waba_id });
            setPhoneNumberId(phone_number_id);
            setWabaId(waba_id);
            setIsOpen(true);
          } else {
            const { current_step } = data.data;
            console.log(`User did not finish ESU. Last step: ${current_step}`);
          }
        }
      } catch {
        return;
      }
    };

    window.addEventListener('message', embeddedSignupInfoListener);

    return () => {
      window.removeEventListener('message', embeddedSignupInfoListener);
    };
  }, []);

  useEffect(() => {
    const script = document.createElement('script');

    script.src = 'https://connect.facebook.net/en_US/sdk.js';
    script.async = true;
    script.crossOrigin = 'anonymous';

    script.onload = () => {
      window['fbAsyncInit'] = function () {
        window['FB'].init({
          appId: '713465632346513', // Your Meta App ID
          version: 'v18.0', // Meta Graph API version
        });
      };
    };

    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  const handleClick = () => {
    // Launch Facebook login
    window['FB'].login(
      function (response) {
        // Since you are using Twilio's APIs, you do not need to do anything with the response here.
        console.log('response: ', response);
      },
      {
        config_id: '2146009695783931',
        auth_type: 'rerequest', // avoids "user is already logged" in errors if users click the button again before refreshing the page
        response_type: 'code',
        override_default_response_type: true,
        extras: {
          sessionInfoVersion: 2, // required to get WABA ID
          // leave below commented for now, you will need to replace this once your app is approved by Meta
          // setup: {
          //   solutionID: SOLUTION_ID,
          // }
        },
      },
    );
  };

  return (
    <>
      <Page.Section
        title="WhatsApp"
        controls={
          <button onClick={() => handleClick()} className={styles.button}>
            Login with Facebook
          </button>
        }
      />
      <Modal
        isOpen={isOpen}
        onClose={() => {
          setIsOpen(false);
        }}
      >
        <ModalHead title="WA EMBEDDED SIGNUP" />
        <ModalBody>
          <p>WABA ID: {wabaId}</p>
          <p>Phone Number ID: {phoneNumberId}</p>
        </ModalBody>
        <ModalFoot
          confirmName="Close"
          confirmOnClick={() => setIsOpen(false)}
        />
      </Modal>
    </>
  );
};
